export default __webpack_public_path__ + "static/media/mascote-cabeca.580ee670.webp";